import BaseTabs from './BaseTabs';

class FaqTabs extends BaseTabs {
  constructor() {
    super('faq-tabs');
  }

  initializeElement(element) {
    super.initializeElement(element);
    this.setupAccordion(element);
  }

  setupAccordion(element) {
    element.querySelectorAll('.faq-accordion__item').forEach((item) => {
      const question = item.querySelector('.faq-accordion__question');
      if (question) {
        question.addEventListener('click', () => item.classList.toggle('is-open'));
      }
    });
  }

  updateSelectDisplay({ selectButton, selectOptions }, value) {
    const selected = Array.from(selectOptions).find((opt) => opt.dataset.value === value);
    if (!selected) return;

    const icon = selected.querySelector('.faq-tabs__select-icon');
    const text = selected.querySelector('span')?.textContent || '';
    const content = selectButton.querySelector('.faq-tabs__select-content');

    const iconHTML = icon ? `<img src="${icon.src}" alt="" class="faq-tabs__select-icon" />` : '';
    content.innerHTML = `${iconHTML}<span class="faq-tabs__select-text">${text}</span>`;
  }

  static init() {
    new FaqTabs();
  }
}

export default FaqTabs;
